var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:['snackbar', _vm.error ? 'red_error' : '']},[_c('span',{staticClass:"snackbar_text"},[_c('v-icon',{staticClass:"mr-2",class:_vm.iconClass,attrs:{"color":_vm.iconColor}}),_c('span',{staticClass:"snackbar_text_massage"},[_vm._v(_vm._s(_vm.message))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }